<template>
  <b-row>
    <div v-for="field in fields" :key="field.key" class="w-100">
      <b-col class="col-12" v-if="!field.engagement">
        <validation-provider rules="required">
          <b-form-group>
            <label class="label-form">
              {{ $t(field.label) }} 
              <feather-icon :id="field.key" icon="InfoIcon" size="20" class="text-dark cursor-pointer" v-if="field.tooltip"></feather-icon>
              <b-popover triggers="hover" placement="top" :target="field.key">
                <div v-html="$t(field.tooltip)"></div>
              </b-popover>
            </label>
            <b-input-group class="m-auto">
              <b-input-group-prepend is-text>
                <component :is="field.icon.type" :icon="field.icon.name" />
              </b-input-group-prepend>
              <input-number-comma
                :price="mutable_content[field.key]"
                :identifier="field.key"
                @changeValue="changeValue"
                :placeholder="$t(field.placeholder)"
              />
            </b-input-group>
          </b-form-group>

          
        </validation-provider>
      </b-col>

      <!-- Engagements readonly -->
      <b-col class="col-12" v-else>
        <b-form-group>
          <label class="label-form">
            {{ $t(field.label) }} 
            <feather-icon :id="field.key" icon="InfoIcon" size="20" class="text-dark cursor-pointer" v-if="field.tooltip"></feather-icon>
            <b-popover triggers="hover" placement="top" :target="field.key" custom-class="popover-large-custom-tooltip-invitation">
              <div v-html="$t(field.tooltip)"></div>
            </b-popover>
          </label>
          <b-input-group class="m-auto">
            <b-input-group-prepend is-text>
               <component :is="field.icon.type" :icon="field.icon.name" />
            </b-input-group-prepend>
            <b-form-input v-model="engagements" readonly :placeholder="$t(field.placeholder)"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </div>

    <b-col cols="12">
      <b-row class="d-flex justify-content-center my-2 px-1">
        <b-button
          variant="dark-button-custom-content-right-link-invitation"
          class="dark-button-custom-content-right-link-invitation w-100"
          :disabled="external_form || are_fields_valid"
          @click="onSubmit()"
        >
          {{$t('dashboard.save')}}
        </b-button>
      </b-row>
    </b-col>
  </b-row>
  
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { required } from "@validations";

import {
  BInputGroup,
  BInputGroupPrepend,
  BCol,
  BRow,
  BButton,
  BFormGroup,
  BIcon,
  BFormInput,
  BPopover
} from "bootstrap-vue";
import inputNumberComma from "@/views/components/inputs/inputNumberComma.vue";
import { separatebycomma } from '@/libs/utils/formats'

export default {
  name: 'formEngagements',
  components: {
    ValidationProvider,
    BInputGroup,
    BInputGroupPrepend,
    BCol,
    BRow,
    BButton,
    BFormGroup,
    inputNumberComma,
    BIcon,
    BFormInput,
    BPopover
  },
  data() {
    return {
      separatebycomma,
      required,
      engagements: 0,
      mutable_content: {},
      show_likes: true,
      show_comments: true,
      show_saved: true, 
    };
  },
  computed: {
    fields() {
      return [
        {
          key: 'number_of_views',
          label: 'campaigns.views',
          icon: {type: 'feather-icon', name: 'EyeIcon'},
          placeholder: 'youtube.visualizations',
          tooltip: 'invitation.html.views',
        },
        {
          key: 'number_of_impressions',
          label: 'campaigns.impressions_label',
          icon: {type: 'feather-icon', name: 'UsersIcon'},
          placeholder: 'campaigns.impressions_placeholder',
        },
        {
          key: 'number_of_interactions',
          label: 'invitation.interactions',
          icon: {type: 'feather-icon', name: 'SmileIcon'},
          placeholder: 'invitation.interactions',
          engagement: true,
          tooltip: 'invitation.html.interactions',
        },
        {
          key: 'number_of_likes',
          label: 'campaigns.likes_label',
          icon: {type: 'b-icon', name: 'heart-fill'},
          placeholder: 'campaigns.likes_placeholder',
        },
        {
          key: 'number_of_comments',
          label: 'campaigns.comments_label',
          icon: {type: 'b-icon', name: 'chat'},
          placeholder: 'campaigns.comments_placeholder',
        },
        {
          key: 'number_of_times_saved',
          label: 'campaigns.saved_label',
          icon: {type: 'b-icon', name: 'bookmark'},
          placeholder: 'campaigns.saved_placeholder',
        },
        {
          key: 'number_of_shares',
          label: 'campaigns.shares_label',
          icon: {type: 'b-icon', name: 'box-arrow-up-right'},
          placeholder: 'campaigns.shares_placeholder',
        }
      ];
    },
    are_fields_valid() {
      const requiredFields = [
        'number_of_views',
        'number_of_impressions',
        'number_of_likes',
        'number_of_comments',
        'number_of_shares',
        'number_of_times_saved'
      ];
      return !requiredFields.every((key) => this.mutable_content[key] !== null &&
        this.mutable_content[key] !== undefined &&
        this.mutable_content[key].toString().trim() !== ''
      );
    },
  },
  props: {
    external_form: {
      type: Boolean,
      default: true
    },
    content: {
      required: true,
      type: Object,
    },
    net: {
      required: true,
      type: String,
    },
    new_layout: {
      type: Boolean
    },
  },
  created() {
    this.mutable_content = this.content;
    
    if (this.mutable_content.content_type === 'podcast') {
      this.show_likes = false
      this.show_comments = false
    }

    if (this.mutable_content.network === 'blog') {
      this.show_likes = false
      if (this.mutable_content.content_type === 'post') this.show_saved = false
    }

    if (this.mutable_content.content_type === 'streaming' || this.mutable_content.content_type === 'clip' || this.mutable_content.content_type === 'story') this.show_saved = false

    const total = this.mutable_content.number_of_likes + this.mutable_content.number_of_comments + this.mutable_content.number_of_shares + this.mutable_content.number_of_times_saved
    this.engagements = separatebycomma(total)
  },
  methods: {
    changeValue(new_value, key) {
      this.content[key] = new_value
      const total = this.mutable_content.number_of_likes + this.mutable_content.number_of_comments + this.mutable_content.number_of_shares + this.mutable_content.number_of_times_saved;
      this.engagements = separatebycomma(total)
    },
    onSubmit() {
      const new_data = {
        views: this.mutable_content.number_of_views,
        impressions: this.mutable_content.number_of_impressions,
        likes: this.mutable_content.number_of_likes,
        comments: this.mutable_content.number_of_comments,
        shares: this.mutable_content.number_of_shares,
        saved: this.mutable_content.number_of_times_saved
      }

      this.$emit('onSubmit', new_data)
    },
  },
};
</script>
<style lang="scss">
.popover-large-custom-tooltip-invitation {
  max-width: 400px !important;
  @media (max-width: 576px) {
    max-width: 300px !important;
  }
}
</style>
<style lang="scss" scoped>
.label-form {
  font-size: 14px;
  margin-bottom: 0.5em
}
</style>